type FormatTokenAmountOptions = {
  trimTrailingZeros?: boolean;
  maxFractionDigits?: number;
};

const addThousandsSeparators = (value: string): string =>
  value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const formatTokenAmount = (
  amount: bigint,
  decimals: number,
  options: FormatTokenAmountOptions = {},
): string => {
  const { trimTrailingZeros = true, maxFractionDigits } = options;
  const safeDecimals = Number.isFinite(decimals) && decimals > 0
    ? Math.floor(decimals)
    : 0;

  const isNegative = amount < 0n;
  const absAmount = isNegative ? -amount : amount;
  const sign = isNegative ? "-" : "";

  if (safeDecimals === 0) {
    return `${sign}${addThousandsSeparators(absAmount.toString())}`;
  }

  const base = 10n ** BigInt(safeDecimals);
  const whole = absAmount / base;
  let fraction = (absAmount % base).toString().padStart(safeDecimals, "0");

  if (
    typeof maxFractionDigits === "number" &&
    maxFractionDigits >= 0 &&
    maxFractionDigits < safeDecimals
  ) {
    fraction = fraction.slice(0, maxFractionDigits);
  }

  if (trimTrailingZeros) {
    fraction = fraction.replace(/0+$/, "");
  }

  const wholeStr = addThousandsSeparators(whole.toString());
  if (fraction.length === 0) {
    return `${sign}${wholeStr}`;
  }

  return `${sign}${wholeStr}.${fraction}`;
};
